import 'css-chunksrc/client/pages/eventPage/timestamp/styles.scss';export default {
  "timestamp": "_timestamp_19rhv_1",
  "dates": "_dates_19rhv_6",
  "row": "_row_19rhv_10",
  "date": "_date_19rhv_6"
};